import React from "react";
import { INOSSelectContainer } from "@interfaces/Components";
import classNames from "classnames";

const NOSSelectContainer: React.FC<INOSSelectContainer> = (props) => {
  return (
    <div
      className={classNames("rounded-md border-[1px] border-solid border-grey-40 bg-white overflow-hidden", {
        "mb-4": props.bottomMargin,
      })}
    >
      {props.children}
    </div>
  );
};

export default NOSSelectContainer;
